import axios from '../utils/axios';

export default function fetchCourseMappingList(adminId,params) {
    return (
        axios.get('/admin/' + adminId +'/courses/course-mapping',  {params} )
    )
}